import * as React from 'react';
import { Link as MuiLink, LinkProps as MuiLinkProps } from '@material-ui/core';
import { buttonLink, linkColor } from 'bento/Link/linkCssDefs';
import Anchor from 'components/Anchor';

export interface LinkProps extends Omit<MuiLinkProps, 'color'> {
  component?: React.ElementType;
  external?: boolean;
  color?: 'default' | 'inherit';
}

/**
 * Link should be used for all text link navigation. It uses the Anchor component internally, which will generate either a react-router link or a regular link.
 *
 * ```js
 * import { Link } from 'bento';
 * ```
 * @deprecated Deprecated — use pantry Link instead.
 * @see https://docs.tocktix.com/pantry?path=/docs/components-link--docs
 * Migration: Replace Link with the pantry Link component.
 */
export const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
  (
    {
      component = Anchor,
      color = 'default',
      underline = 'always',
      children,
      external,
      target,
      ...rest
    },
    ref
  ) => {
    return (
      <MuiLink
        component={component}
        css={[buttonLink, linkColor(color)]}
        underline={underline}
        ref={ref}
        target={external ? 'blank' : target}
        {...rest}
      >
        {children}
        {external && ' ↗'}
      </MuiLink>
    );
  }
);
